<script>
    export let display = false
    export let size = "tiny"
</script>

<style>
    .modal {
        max-height: 90%;
        overflow-y: auto;
    }
</style>

{#if display}
    <div class="ui dimmer modals page transition visible active" style="display: flex !important;">
        <div class="ui {size} modal transition visible active scrolling" style="display: block !important;">
            <slot name="header"></slot>
            <slot name="content"></slot>
            <slot name="actions"></slot>
        </div>
    </div>
{/if}